// extracted by mini-css-extract-plugin
export default {"root":"SCXXj__root","warningSign":"PyRdS__warningSign","smallSizePlayer":"GsZr1__smallSizePlayer"};